import { Switch, UIText1 } from '@cian/ui-kit';
import { AutoprolongHintContainer } from '../../../AutoprolongHint';
import * as React from 'react';
import { SectionContainer } from '../Section';
import * as styles from './Autoprolong.css';

interface IProps {
  checked: boolean;
  onChange: (_: unknown, checked: boolean) => void;
}

export const Autoprolong = ({ checked, onChange }: IProps) => (
  <SectionContainer>
    <div className={styles['wrapper']}>
      <div className={styles['switcher']}>
        <UIText1>Автопродление</UIText1>
        <div className={styles['hint']}>
          <AutoprolongHintContainer />
        </div>
      </div>
      <Switch onChange={onChange} checked={checked} data-mark="BuyConfirmationModalMobile|autoprolong" />
    </div>
  </SectionContainer>
);
